import axios from 'axios';
import wixApplication from 'wix-application';
import React, { useState } from 'react';
import { render, W } from '@wix/react-velo';
import { _app } from 'public/config'
import * as Sentry from "@sentry/react";

function App() {
    const [data, setData] = useState(null);

    useState(() => {
        const auth = wixApplication.getAppInstance()
        Sentry.addBreadcrumb({
            category: "appInstanceToken",
            message: auth,
            level: "info",
        });
        const api = axios.create({
            baseURL: `https://certifiedcode.wixsite.com/${_app.slug}/_functions/@certifiedcode/base-reviews-backend`,
            headers: {
                'Authorization': auth
            }
        });
        const fetchData = async () => {
            api.post('/v1/getProfile', [])
                .then(function (response) {
                    setData(response.data.object)
                })
                .catch(function (error) {
                    console.log(error);
                });
        };

        fetchData();

        wixApplication.getDecodedAppInstance()
            .then((instance) => {
                Sentry.setUser({ id: instance.instanceId });
                Sentry.setContext("instance", instance);
            })
    }, [])

    useState(() => {
        console.log(data)
    }, [data])

    return (
        <W.Root>
        <W.Badge link={data?.source_url} text={`${data?.average_rating}${data?.sample ? ' (sample)' : ''}`} />
    </W.Root>
    );
}

$w.onReady(() => {
    Sentry.init({
        dsn: "https://7a260f27f460d8e013971d41770b246f@o4505471689687040.ingest.sentry.io/4506801187848192",
        integrations: [
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
            }),
        ],
        tracesSampleRate: 1.0,
        // tracePropagationTargets: [],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });

    render(App, $w, React)
});